import { ValidationRule } from './validationRule';

export function ValidateRuleDirective(validationRules) {
  'ngInject';

  const directive = new ValidationRule();

  directive.scope = {
    validateRule: '<'
  };

  directive.ignoreWhitespace = true;

  directive.link = (scope, element, attrs, ctrl) => {
    const rules = validationRules.getRules();

    scope.$watch('validateRule', validateRule => {
      if (validateRule) {
        validateRule.split(',').map(rule => {
          let validationRule = rules[rule];
          if (validationRule) {
            let validator = (value, valid) => valid;
            directive.parser(ctrl, rule, validationRule, validator);
            directive.formatter(ctrl, rule, validationRule, validator);
            directive.validator(ctrl, rule, validationRule, validator);
          }
        });
        ctrl.$validate();
      }
    });
  };

  return directive;
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-form-validation/src/validateRule.directive.js